import { Injectable, signal } from '@angular/core';
import { StorageHelper } from '@helpers/storage.helper';

@Injectable({ providedIn: 'root' })
export class CurrentUserRolesService {
  private readonly _roles = signal<string[]>(StorageHelper.getRoles() ?? []);
  readonly roles = this._roles.asReadonly();

  hasRole(...roles: (string | string[])[]): boolean {
    const candidateRoles = roles.flatMap(role => Array.isArray(role) ? role : [role]);
    return candidateRoles.some(role => this._roles().includes(role));
  }

  setRoles(roles: string[]): void {
    this._roles.set(roles);
    StorageHelper.setRoles(roles);
  }

  loadFromStorage(): string[] | null {
    const roles = StorageHelper.getRoles();
    if (roles !== null) this._roles.set(roles);
    return roles;
  }

  clear(): void {
    this._roles.set([]);
    StorageHelper.removeRoles();
  }
}
